
// Horizontal filter layout - added by Joey 02-2021

var filters = 'hidden'; // my var set for use below
var pathArray = window.location.pathname.split('/');
var baseURL = window.location.origin +'/'+ pathArray[1] +'/'+ pathArray[2];
var filterCatSet = false;
var filterMetalSet = false;
var filterPriceSet = false;
var filterStr = String(pathArray[3]);
if (filterStr.includes('category')) { filterCatSet = true; }
if (filterStr.includes('metal')) { filterMetalSet = true; }
if (filterStr.includes('price')) { filterPriceSet = true; }

console.log('cat: '+filterCatSet);
console.log('metal: '+filterMetalSet);
console.log('price: '+filterPriceSet);

function filterMenuSetup() {
  
  $('.CollectionFilters .horizontal-layout .Collapsible .Collapsible__Inner').hide();


  $('.CollectionFilters .horizontal-layout .Collapsible').on( "click", function() {

        if (filters == 'hidden') {
          $('.CollectionFilters .horizontal-layout').animate({height:200},200);
          $(this).children('.Collapsible__Inner').show(200).addClass('open');
          filters = 'showing';
        } else { 
          if (filters == 'showing' && $(this).children('.Collapsible__Inner').hasClass('open')) {
            $('.CollectionFilters .horizontal-layout').animate({height:46},200);
            $('.CollectionFilters .horizontal-layout .Collapsible .Collapsible__Inner').hide(200).removeClass('open');
            filters = 'hidden';
          } else {
            $(this).children('.Collapsible__Inner').show(200).addClass('open');
          }
        }
  });

  $('.CollectionFilters .horizontal-layout .Linklist__Item').on( "click", function() {
    var filterTag = event.target.getAttribute("data-tag");
    //console.log(filterTag);
    
    // second filter
    if (pathArray[3]) { 
     if (filterCatSet==true && filterTag.includes('category')) { filterLink = baseURL +'/'+ filterTag; } 
     else if (filterMetalSet==true && filterTag.includes('metal')) { filterLink = baseURL +'/'+ filterTag; } 
     else if (filterPriceSet==true && filterTag.includes('price')) { filterLink = baseURL +'/'+ filterTag; } 
     else { filterLink = window.location.href +'+'+ filterTag; }
    // first filter
    } else {
     filterLink = baseURL +'/'+ filterTag; 
    }
      console.log(baseURL +'/'+ filterTag);
    window.location.href = filterLink;
  });

  // if filters are engaged, change filter label
  if (pathArray[3]) {
    $('.filters-title div').html('Reset');
    $('.filters-title').css('cursor','pointer')
    $('.filters-title').on( "click", function() {
      window.location.href = baseURL;
    });
  }

  // change list items color from white to grey (white in css to hide flash)
  $('.CollectionFilters .horizontal-layout .Linklist__Item .Text--subdued').css('color','#174b69');


  
} //filterMenuSetup





// Run the function when jQuery has loaded
var waitForJQuery = setInterval(function () {
    if (typeof $ != 'undefined') {

      console.log('jQuery loaded');
      
      filterMenuSetup(); 

      clearInterval(waitForJQuery);
    }
}, 10);